export default __webpack_public_path__ + "static/media/julian_xl.88edfb77.jpg";